// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Main container for the progress bar */
.progressbar {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-content: center;
  counter-reset: step;
  margin: var(--spacing-large) auto;
  width: 90%;
}

/* Styles for each step item in the progress bar */
.barItem {
  width: 2.1875rem;
  height: 2.1875rem;
  background-color: #dcdcdc;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 1;
}

/* Adds numbers to each step, automatically incrementing */
.barItem::before {
  counter-increment: step;
  content: counter(step);
}

/* Displays the title of each step below the circle */
.barItem::after {
  content: attr(data-title);
  position: absolute;
  top: calc(100% + 0.5rem);
  font-size: var(--font-size-small);
  color: #666;
  text-align: center;
}

@media (max-width: 400px) {
  .barItem::after {
    display: none;
  }
}
/* Styles for selected/completed steps */
.selectedBarItem {
  background-color: var(--ion-color-primary);
  color: #f3f3f3;
}

/* Creates the background line connecting all steps */
.progressbar::before,
.progress {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 4px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.12);
  z-index: 0;
  border-radius: 4px;
}

/* Colored line representing current progress — gradient degradé from primary to a lighter fade */
.progress {
  background: linear-gradient(to right, var(--ion-color-primary-shade), var(--ion-color-primary), rgba(var(--ion-color-primary-rgb), 0.35));
  transition: width 0.4s ease;
  z-index: 0;
  border-radius: 4px;
}

.modal-button {
  border-radius: 16px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/form-progress-bar/form-progress-bar.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,wCAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,mBAAA;EACA,iCAAA;EACA,UAAA;AAEF;;AACA,kDAAA;AACA;EACE,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AAEF;;AACA,0DAAA;AACA;EACE,uBAAA;EACA,sBAAA;AAEF;;AACA,qDAAA;AACA;EACE,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,iCAAA;EACA,WAAA;EACA,kBAAA;AAEF;;AACA;EACE;IACE,aAAA;EAEF;AACF;AACA,wCAAA;AACA;EACE,0CAAA;EACA,cAAA;AACF;;AAEA,qDAAA;AACA;;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,UAAA;EACA,kBAAA;AACF;;AAEA,iGAAA;AACA;EACE,yIAAA;EAMA,2BAAA;EACA,UAAA;EACA,kBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,WAAA;AAJF","sourcesContent":["/* Main container for the progress bar */\r\n.progressbar {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-content: center;\r\n  counter-reset: step;\r\n  margin: var(--spacing-large) auto;\r\n  width: 90%;\r\n}\r\n\r\n/* Styles for each step item in the progress bar */\r\n.barItem {\r\n  width: 2.1875rem;\r\n  height: 2.1875rem;\r\n  background-color: #dcdcdc;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: relative; // ensure circles stack above the connecting line\r\n  z-index: 1;\r\n}\r\n\r\n/* Adds numbers to each step, automatically incrementing */\r\n.barItem::before {\r\n  counter-increment: step;\r\n  content: counter(step);\r\n}\r\n\r\n/* Displays the title of each step below the circle */\r\n.barItem::after {\r\n  content: attr(data-title);\r\n  position: absolute;\r\n  top: calc(100% + 0.5rem);\r\n  font-size: var(--font-size-small);\r\n  color: #666;\r\n  text-align: center;\r\n}\r\n\r\n@media (max-width: 400px) {\r\n  .barItem::after {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* Styles for selected/completed steps */\r\n.selectedBarItem {\r\n  background-color: var(--ion-color-primary);\r\n  color: #f3f3f3;\r\n}\r\n\r\n/* Creates the background line connecting all steps */\r\n.progressbar::before,\r\n.progress {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  height: 4px;\r\n  width: 100%;\r\n  background-color: rgba(0, 0, 0, 0.12);\r\n  z-index: 0;\r\n  border-radius: 4px;\r\n}\r\n\r\n/* Colored line representing current progress — gradient degradé from primary to a lighter fade */\r\n.progress {\r\n  background: linear-gradient(\r\n    to right,\r\n    var(--ion-color-primary-shade),\r\n    var(--ion-color-primary),\r\n    rgba(var(--ion-color-primary-rgb), 0.35)\r\n  );\r\n  transition: width 0.4s ease;\r\n  z-index: 0;\r\n  border-radius: 4px;\r\n}\r\n\r\n.modal-button {\r\n  border-radius: 16px;\r\n  width: 100%;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
